export function getMapTools (state, value) {
  return state.mapTools
}
